module.exports = __webpack_public_path__ + "img/shipping_compressed.47a474a1.jpg";